import { render, staticRenderFns } from "./SpinningAnimation.vue?vue&type=template&id=66a6a3e3&scoped=true"
import script from "./SpinningAnimation.vue?vue&type=script&lang=js"
export * from "./SpinningAnimation.vue?vue&type=script&lang=js"
import style0 from "./SpinningAnimation.vue?vue&type=style&index=0&id=66a6a3e3&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "66a6a3e3",
  null
  
)

export default component.exports